import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t border-paper-300 bg-white py-6 px-4 md:px-8">
      <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-paper-500">
        <div className="flex items-center gap-2">
          <span className="font-serif font-bold tracking-[0.06em] text-navy-900">SENTANTIA</span>
          <span>&middot;</span>
          <span>Litigation Intelligence</span>
        </div>
        <div className="flex items-center gap-4">
          <Link to="/dashboard?tour=restart" className="hover:text-navy-900 transition-colors">
            Tour
          </Link>
          <Link to="/help" className="hover:text-navy-900 transition-colors">
            Help Center
          </Link>
          <Link to="/pricing" className="hover:text-navy-900 transition-colors">
            Pricing
          </Link>
          <Link to="/privacy" className="hover:text-navy-900 transition-colors">
            Privacy Policy
          </Link>
          <Link to="/terms" className="hover:text-navy-900 transition-colors">
            Terms of Service
          </Link>
          <Link to="/support" className="hover:text-navy-900 transition-colors">
            Support
          </Link>
        </div>
        <div className="text-xs text-paper-400">
          &copy; {new Date().getFullYear()} Sentantia. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
